module.exports = __webpack_public_path__ + "img/bxs_lock-open.f8985caf.svg";